import { Fragment } from 'react'
import {
    AGE_VERIFICATION,
    EMOJIS,
    GALLERY_ALBUM_IMAGE,
    HIDE_FLOATING_PLAYER,
    MENU,
    QUICKBUY,
    RULE_VIOLATION,
    WHITEBOARD,
} from '../../../../constants/dialogs'
import Whiteboard from '../../Whiteboard'
import AgeVerification from './AgeVerification'
import EmojiPicker from './EmojiPicker'
import HideFloatingPlayer from './HideFloatingPlayer'
import Menu from './Menu'
import PrivateGalleryImage from './PrivateGalleryImage'
import QuickBuy from './QuickBuy'
import RuleViolation from './RuleViolation'

export default {
    [AGE_VERIFICATION]: AgeVerification,
    [EMOJIS]: EmojiPicker,
    [GALLERY_ALBUM_IMAGE]: PrivateGalleryImage,
    [HIDE_FLOATING_PLAYER]: HideFloatingPlayer,
    [MENU]: Menu,
    [QUICKBUY]: QuickBuy,
    [RULE_VIOLATION]: RuleViolation,
    [WHITEBOARD]: Whiteboard,
    NOOP: Fragment,
}
